import { Component } from '@angular/core';

@Component({
  selector: 'rs-great-message',
  templateUrl: 'great-message.component.html'
})
export class GreatMessageComponent {}
